module.exports = __webpack_public_path__ + "img/9a5dd9e.png";